import { ChangeDetectionStrategy, Component } from "@angular/core";

/**
 * Never constructed. `landingPageRedirectGuard` always returns a `UrlTree`, so the
 * router cancels the navigation before activating anything on `path: ""`.
 *
 * It exists only to satisfy the router's own config rule: every route must
 * declare one of `component`, `loadComponent`, `redirectTo`, `children` or
 * `loadChildren` (NG04014), and `redirectTo` cannot sit alongside a guard —
 * so a component is the legible way to satisfy it. Giving it a template would
 * be writing code that cannot run.
 */
@Component({
    selector: "app-landing-page-placeholder",
    template: "",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingPagePlaceholderComponent {}
